import gql from 'graphql-tag';
import _ from 'lodash';

export const getEducationTags = gql`
  query EduTag {
    educationTags {
      id
      name
      logo
      parentId
      isParentGroup
      viewMode
    }
  }
`;

// [{title, imagePath, data:[]]
// {title, image, id}

export const converter = (tagList = []) => {
  const groupedList = _.groupBy(tagList, t => t.parentId);

  const parent = groupedList[0] || [];

  const result = parent.map(p => ({
    id: p.id,
    title: p.name,
    imagePath: p.logo,
    data: groupedList[p.id]
      ? groupedList[p.id].map(s => ({
          id: s.id,
          title: s.name,
          image: s.logo,
          mode: s.viewMode,
        }))
      : [],
  }));

  return {
    sectionedList: result,
  };
};
